import { render, staticRenderFns } from "./optionsViewer.vue?vue&type=template&id=3f64dc35&scoped=true"
import script from "./optionsViewer.vue?vue&type=script&lang=js"
export * from "./optionsViewer.vue?vue&type=script&lang=js"
import style0 from "./optionsViewer.vue?vue&type=style&index=0&id=3f64dc35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64dc35",
  null
  
)

export default component.exports